import React from "react";
import PaletteCouleursAffichageToutes from "../../../../boiteAOutils/PaletteCouleursAffichageToutes";

const shapeTypes = [
    {
        type: "rect",
        svg: (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 1.5H2C1.71875 1.5 1.5 1.75 1.5 2V12C1.5 12.2812 1.71875 12.5 2 12.5H12C12.25 12.5 12.5 12.2812 12.5 12V2C12.5 1.75 12.25 1.5 12 1.5ZM2 0H12C13.0938 0 14 0.90625 14 2V12C14 13.125 13.0938 14 12 14H2C0.875 14 0 13.125 0 12V2C0 0.90625 0.875 0 2 0Z"
                    fill="#002335"
                />
            </svg>
        )
    },
    {
        type: "circle",
        svg: (
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9062 12C14.4688 14.5 11.8438 16 9 16Z"
                    fill="#002335"
                />
            </svg>
        )
    }, {
        type: "line",
        customType: "line",
        svg: (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 21.5L22 10.5" stroke="#002335" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        )
    }, {
        type: "rhombus",
        customType: "rhombus",
        svg: (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.78125 1.59375L1.5625 7.78125C1.53125 7.84375 1.5 7.9375 1.5 8C1.5 8.09375 1.53125 8.1875 1.5625 8.21875L7.78125 14.4375C7.8125 14.4688 7.90625 14.5 8 14.5C8.0625 14.5 8.15625 14.4688 8.21875 14.4375L14.4062 8.21875C14.4688 8.1875 14.5 8.09375 14.5 8C14.5 7.9375 14.4688 7.84375 14.4062 7.78125L8.21875 1.59375C8.15625 1.53125 8.0625 1.5 8 1.5C7.90625 1.5 7.8125 1.53125 7.78125 1.59375ZM0.53125 6.71875L6.71875 0.53125C7.03125 0.21875 7.5 0 8 0C8.46875 0 8.9375 0.21875 9.28125 0.53125L15.4688 6.71875C15.7812 7.0625 16 7.53125 16 8C16 8.5 15.7812 8.96875 15.4688 9.28125L9.28125 15.4688C8.9375 15.8125 8.46875 16 8 16C7.5 16 7.03125 15.8125 6.71875 15.4688L0.53125 9.28125C0.1875 8.96875 0 8.5 0 8C0 7.53125 0.1875 7.0625 0.53125 6.71875Z"
                    fill="#002335"/>
            </svg>
        )
    }, {
        type: "triangle",
        svg: (
            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.75 1.65625L1.5625 11.8125C1.5 11.9062 1.5 11.9688 1.5 12.0625C1.5 12.3125 1.6875 12.5 1.9375 12.5H14.0312C14.2812 12.5 14.5 12.3125 14.5 12.0625C14.5 11.9688 14.4688 11.9062 14.4062 11.8125L8.21875 1.65625C8.1875 1.5625 8.09375 1.5 8 1.5C7.875 1.5 7.8125 1.5625 7.75 1.65625ZM6.46875 0.875C6.78125 0.34375 7.375 0 8 0C8.59375 0 9.1875 0.34375 9.5 0.875L15.6875 11.0312C15.875 11.3438 16 11.6875 16 12.0625C16 13.125 15.125 14 14.0312 14H1.9375C0.875 14 0 13.125 0 12.0625C0 11.6875 0.09375 11.3438 0.28125 11.0312L6.46875 0.875Z"
                    fill="#002335"/>
            </svg>
        )
    }, {
        type: "star",
        customType: "star",
        svg: (
            <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.96875 0C9.28125 0 9.53125 0.1875 9.65625 0.4375L11.8125 4.84375L16.5938 5.5625C16.875 5.59375 17.0938 5.78125 17.1875 6.0625C17.2812 6.34375 17.2188 6.625 17 6.84375L13.5312 10.2812L14.3438 15.125C14.4062 15.4062 14.2812 15.7188 14.0625 15.875C13.8125 16.0312 13.5 16.0625 13.25 15.9375L8.96875 13.625L4.71875 15.9375C4.4375 16.0625 4.15625 16.0312 3.90625 15.875C3.6875 15.6875 3.5625 15.4062 3.625 15.125L4.4375 10.2812L0.96875 6.84375C0.75 6.625 0.6875 6.34375 0.78125 6.0625C0.875 5.8125 1.09375 5.59375 1.375 5.5625L6.15625 4.84375L8.3125 0.4375C8.4375 0.1875 8.6875 0 8.96875 0ZM8.96875 2.46875L7.34375 5.875C7.21875 6.09375 7.03125 6.25 6.78125 6.28125L3.09375 6.8125L5.75 9.46875C5.9375 9.65625 6.03125 9.90625 5.96875 10.125L5.34375 13.875L8.625 12.125C8.84375 12 9.125 12 9.34375 12.125L12.625 13.875L12 10.1562C11.9375 9.90625 12.0312 9.65625 12.2188 9.5L14.875 6.8125L11.1875 6.28125C10.9375 6.25 10.75 6.09375 10.625 5.875L8.96875 2.46875Z"
                    fill="#002335"/>
            </svg>
        )
    }, {
        type: "hexagon",
        customType: "hexagon",
        svg: (
            <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.53125 5.875L3.28125 1.125C3.6875 0.40625 4.40625 0 5.21875 0H10.75C11.5625 0 12.2812 0.40625 12.6875 1.125L15.4375 5.875C15.8438 6.59375 15.8438 7.4375 15.4375 8.125L12.6875 12.9062C12.2812 13.625 11.5625 14.0312 10.75 14.0312H5.21875C4.4375 14.0312 3.6875 13.625 3.28125 12.9062L0.53125 8.125C0.125 7.4375 0.125 6.59375 0.53125 5.875ZM1.8125 7.375L4.5625 12.1562C4.71875 12.4062 4.96875 12.5312 5.21875 12.5312H10.75C11 12.5312 11.25 12.4062 11.4062 12.1562L14.1562 7.375C14.2812 7.15625 14.2812 6.875 14.1562 6.625L11.4062 1.875C11.25 1.625 11 1.5 10.75 1.5H5.21875C4.96875 1.5 4.71875 1.625 4.5625 1.875L1.8125 6.625C1.6875 6.875 1.6875 7.15625 1.8125 7.375Z"
                    fill="#002335"/>
            </svg>
        )
    }, {
        type: "arrow",
        customType: "arrow",
        svg: (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 19L8 14L16.5 14L16.5 10L25 16.5L16.5 23L16.5 19L8 19Z" stroke="#002335" strokeWidth="1.5"
                      strokeLinejoin="round"/>
            </svg>
        )
    }
    // Ajoute ici d'autres formes : triangle, rhombus, star, hexagon...
];


const SidebarShapeSettings = ({setSidebarVisible, shapeSettings, setShapeSettings, changeSelectedShapeType}) => {
    const {fill, backgroundColor} = shapeSettings;

    return (
        <>
            <div className="sidebar-titre">
                Forme
                <button onClick={() => setSidebarVisible(false)} className="toggle-button">
                    X
                </button>
            </div>

            <div className="sidebar-section">Type de forme</div>
            <div className="sidebar-choix-forme">
                {shapeTypes.map(({type, svg, customType = null}) => (
                    <div
                        key={type}
                        className={shapeSettings.customType === type ? "active" : ""}
                        onClick={() => {
                            setShapeSettings(prev => ({...prev, type, customType}));
                            changeSelectedShapeType(type);
                        }}
                    >
                        {svg}
                    </div>
                ))}
            </div>

            <div className="sidebar-section">Couleur de la forme</div>
            <PaletteCouleursAffichageToutes defaultColor={fill}
                                            onColorChange={(newColor) => setShapeSettings(prev => ({
                                                ...prev,
                                                fill: newColor
                                            }))}/>

            <div className="sidebar-section">Fond de la forme</div>
            <PaletteCouleursAffichageToutes defaultColor={backgroundColor}
                                            onColorChange={(newColor) => setShapeSettings(prev => ({
                                                ...prev,
                                                backgroundColor: newColor === "transparent" ? '' : newColor
                                            }))} showTransparent={true}/>
        </>
    );
};

export default SidebarShapeSettings;
